<template>
	<div>
		<div id="bg_color" class="content-box">
		</div>
		<div id="bg_bottom_img">	
		</div>
		<div class="content-box-1">
			<div class="content-box-title">
				<span>{{ theme.title }}</span>
				<div class="login-info-select-btn" v-if="isLogin && this.$route.name != 'login'">
					<el-dropdown class="dropdown" @command="handleCommand">
						<span class="el-dropdown-link">
							<span>账户：{{userName}}</span>
							<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown" class="el-dropdown-menu">
							<el-dropdown-item command="edit" class="edit">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div class='content-view' v-if="!flag">
				<keep-alive>
					　　<router-view v-if="$route.meta.keepAlive"></router-view>
				</keep-alive>
				<router-view v-if="!$route.meta.keepAlive"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				flag: false,
				userName: '',
				theme: {
					background_color: '',
					background_image: '',
					title: '',
				},
			}
		},
		computed: {
			isLogin() {
				let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
				if(userInfo) {
					if(userInfo.role == 'competition_course_expert') {
						this.userName = userInfo.username.length > 26 ? userInfo.username.substr(0, 26) + ' (专家)' : userInfo.username + ' (专家)'
					} else if(userInfo.role == 'competition_course_filter_expert') {
						this.userName = userInfo.username.length > 24 ? userInfo.username.substr(0, 24) + ' (筛查专家)' : userInfo.username + ' (筛查专家)'
					} else {
						this.userName = userInfo.username.length > 30 ? userInfo.username.substr(0, 30) : userInfo.username
					}
				}
				return this.$store.getters.getState
			},
		},
		methods: {
			handleCommand(command) {
				if (command == 'edit') {
					let id = sessionStorage.getItem('competition_course_poster_id'),
							province_name = sessionStorage.getItem('province_name')
					localStorage.clear()
					sessionStorage.clear()
					this.$store.dispatch("loginState", false);
					// 退出
					this.$router.push({
						name: 'login',
						query: {
							id: id,
							province_name: province_name
						}
					})
					history.pushState(null, null, document.URL);
					window.addEventListener("popstate", function(e) {
						history.pushState(null, null, document.URL);
					}, false);
					this.getDetail()
				}
			},
			initPage() {
				if(this.theme.background_color) {
					document.getElementById("bg_color").style.backgroundColor = this.theme.background_color
				}
				if(this.theme.background_image) {
					document.getElementById("bg_bottom_img").style.backgroundImage = "url('" + this.alOssUrl + String(this.theme.background_image) + "')"
				} else {
					document.getElementById("bg_bottom_img").style.backgroundImage = 'none'
				}
			},
			getDetail() {
				this.HttpUtil.Get(this.api.util.competitionCoursePosterDetail, {
					id: sessionStorage.getItem('competition_course_poster_id') || this.$route.query.id
				}, {
					split_loginRole: true
				}).then(res => {
					sessionStorage.setItem('competition_course_detail', JSON.stringify(res.competition_course_poster))
					this.theme = res.competition_course_poster?.config?.theme?.organization || {
						background_color: '',
						background_image: '',
						title: '',
					}
					this.initPage()
				})
			}
		},
		mounted() {
			this.getDetail()
		}
	}
</script>

<style lang="scss" scoped>
	#bg_bottom_img {
		/* background-image: url(../assets/img/content-bg-bottom.png); */
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 100%;
		min-width: 1220px;
		height: 300px;
		/* height: 31vh; */
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: -998;
	}

	.content-box {
		/* background-image: url(../assets/img/content-bg.png);
		background-repeat: no-repeat;
		background-size: 100% 100%; */
		background-color: rgb(5, 140, 249);
		width: 100%;
		min-width: 1220px;
		height: 100%;
		min-height: 800px;
		position: fixed;
		top: 0;
		left: 0;
		z-index: -999;
	}
	
	.content-box-title {
		/* width: 68%; */
		width: 75vw;
		min-width: 1000px;
		/* height: 70vh; */
		margin: 0 auto;
		padding: 1vw 8vw;
		
		
		/* width: 100%; */
		/* height: 47px; */
		/* font-size: 2.5vw; */
		/* text-align: center; */
		margin-top: 1vw;
		/* margin-bottom: 20px; */
		
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.content-box-title>span {
		/* font-size: 50px; */
		font-size: 1.9vw;
		font-family: Alibaba PuHuiTi;
		font-weight: bold;
		color: #ffffff;
		text-shadow: 3px 4px 0px rgba(0, 99, 145, 0.22);
		/* margin: 3.5vw 0 0 5.5vw; */
		letter-spacing: 5px;
	}

	/* 登录信息 */
	
	.el-dropdown-link {
		color: white !important;
		font-size: 16px;
		cursor: pointer;
		span {
		margin-right: 5px;
		}
	}
	
	.el-icon-arrow-down {
		font-size: 16px;
		color: white;
	}
	
	.el-dropdown-menu {
		width: 150px;
		text-align: center;
	}
	.el-dropdown-menu__item {
		font-size: 14px !important;
		height: 40px !important;
		line-height: 40px !important;
	}
	
	.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background: #F5F5F5 !important;
		color: black;
	}
	
	.edit {
		color: red !important;
	}
	
	.login-info-select-btn {
		float: right;
		font-size: 16px;
		font-weight: 400;
		color: #FFFFFF;
	}

	.content-view {
		margin-top: 1vw;
		min-height: 76vh;
	}
</style>
